import * as types from './types';

export default {
    [types.SET_ACCOMMODATION](state, accommodation) {
        state.accommodation = accommodation;
    },
};